<div class="page" *ngIf="platformBrowser">
  <img [src]="tenant.logo_url" alt="" *ngIf="tenant.logo_url" class="brand-logo" />
  <div class="brand-name" *ngIf="!tenant.logo_url">{{ tenant.name || 'Picflow User' }}</div>

  <div class="socials">
    <a
      appButton
      name="website"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      appTooltip="{{ niceSite(tenant.contacts.site) }}"
      rel="nofollow noreferrer noopener"
      [href]="tenant.contacts.site"
      target="_blank"
      *ngIf="tenant.contacts?.site"
    >
      <app-svg src="/assets/icons/globe.svg"></app-svg>
    </a>

    <a
      appButton
      name="phone"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      appTooltip="{{ tenant.contacts.phone }}"
      rel="nofollow noreferrer noopener"
      [href]="'tel:' + tenant.contacts.phone"
      target="_blank"
      *ngIf="tenant.contacts.phone"
    >
      <app-svg src="/assets/icons/phone.svg"></app-svg>
    </a>

    <a
      appButton
      name="email"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      appTooltip="{{ tenant.contacts.email }}"
      rel="nofollow noreferrer noopener"
      [href]="'mailto:' + tenant.contacts.email"
      target="_blank"
      *ngIf="tenant.contacts.email"
    >
      <app-svg src="/assets/icons/email.svg"></app-svg>
    </a>

    <a
      appButton
      name="facebook"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.facebook.com/' + tenant.socials.facebook"
      target="_blank"
      *ngIf="tenant.socials.facebook"
    >
      <app-svg src="/assets/icons/logo/facebook.svg"></app-svg>
    </a>

    <a
      appButton
      name="instagram"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.instagram.com/' + tenant.socials.instagram"
      target="_blank"
      *ngIf="tenant.socials.instagram"
    >
      <app-svg src="/assets/icons/logo/instagram.svg"></app-svg>
    </a>

    <a
      appButton
      name="pinterest"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://www.pinterest.com/' + tenant.socials.pinterest"
      target="_blank"
      *ngIf="tenant.socials.pinterest"
    >
      <app-svg src="/assets/icons/logo/pinterest.svg"></app-svg>
    </a>

    <a
      appButton
      name="twitter"
      location="tenant-profile-page"
      color="simple-gray"
      [iconButton]="true"
      class="social"
      height="1"
      rel="nofollow noreferrer noopener"
      [href]="'https://twitter.com/' + tenant.socials.twitter"
      target="_blank"
      *ngIf="tenant.socials.twitter"
    >
      <app-svg src="/assets/icons/logo/twitter.svg"></app-svg>
    </a>
  </div>

  <div class="galleries-container">
    <div class="galleries" *ngIf="galleries.length">
      <a *ngFor="let gallery of galleries" [routerLink]="[gallery.path]" target="_blank">
        <app-gallery-item [gallery]="gallery" [publicMode]="true" [showPasswordProtected]="true"></app-gallery-item>
      </a>
    </div>
  </div>

  <div class="no-galleries" *ngIf="!galleries.length" [class.with-logo]="tenant.logo_url">
    <span>There are no galleries to show.</span>
  </div>

  <app-made-with-picflow-button [tenantId]="tenant.id" *ngIf="tenant.picflow_branding_enabled">
  </app-made-with-picflow-button>
</div>

<ng-container *ngIf="!platformBrowser">
  <div class="page center tiny loading">
    <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
  </div>
</ng-container>
